import {
  ElButton,
  ElForm,
  ElFormItem,
  ElInput,
  ElDialog,
  ElTooltip,
  ElPopover,
  ElProgress,
  ElOption,
  ElSteps,
  ElStep,
  ElCheckbox,
  ElSelect,
  ElSlider,
  ElRadio,
  ElRadioGroup,
  ElRadioButton,
  ElTable,
  ElTableColumn,
  ElCascader,
  ElTabs,
  ElTabPane,
  ElRate,
  ElPagination,
  ElAlert,
  ElDropdown,
  ElDropdownMenu,
  ElDropdownItem,
  ElSwitch,
  ElScrollbar,
  ElBadge,
  Collapse,
  CollapseItem,
  notification,
  ElCheckboxGroup,
  ElTransfer,
} from './components/element-ui';

import ElCollapseTransition from 'element-ui/lib/transitions/collapse-transition';

import ElLink from 'element-ui/lib/link';
import ElTag from 'element-ui/lib/tag';
import ElInputNumber from 'element-ui/lib/input-number';

export default function registerGlobalComponents(Vue) {
  notification(Vue);

  Vue.component('ElTransfer', ElTransfer);

  Vue.component('ElAlert', ElAlert);
  Vue.component('ElButton', ElButton);

  Vue.component('ElCascader', ElCascader);
  Vue.component('ElCheckbox', ElCheckbox);
  Vue.component('ElCheckboxGroup', ElCheckboxGroup);
  Vue.component('ElCollapseTransition', ElCollapseTransition);

  Vue.component('ElDialog', ElDialog);
  Vue.component('ElDropdown', ElDropdown);
  Vue.component('ElDropdownMenu', ElDropdownMenu);
  Vue.component('ElDropdownItem', ElDropdownItem);

  Vue.component('ElForm', ElForm);
  Vue.component('ElFormItem', ElFormItem);

  Vue.component('ElInput', ElInput);

  Vue.component('ElOption', ElOption);

  Vue.component('ElPopover', ElPopover);
  Vue.component('ElPagination', ElPagination);
  Vue.component('ElProgress', ElProgress);

  Vue.component('ElRadioGroup', ElRadioGroup);
  Vue.component('ElRadioButton', ElRadioButton);
  Vue.component('ElRate', ElRate);
  Vue.component('ElRadio', ElRadio);

  Vue.component('ElSteps', ElSteps);
  Vue.component('ElStep', ElStep);
  Vue.component('ElSelect', ElSelect);
  Vue.component('ElSlider', ElSlider);
  Vue.component('ElScrollbar', ElScrollbar);
  Vue.component('ElSwitch', ElSwitch);

  Vue.component('ElTooltip', ElTooltip);
  Vue.component('ElTable', ElTable);
  Vue.component('ElTableColumn', ElTableColumn);
  Vue.component('ElTabs', ElTabs);
  Vue.component('ElTabPane', ElTabPane);
  Vue.component('ElTag', ElTag);

  Vue.component('ElLink', ElLink);
  Vue.component('ElBadge', ElBadge);
  Vue.component('ElInputNumber', ElInputNumber);
  Vue.component('ElCollapse', Collapse);
  Vue.component('ElCollapseItem', CollapseItem);
}
